<template>
<q-page class="signup" :class="{'bg-white': !$isDesktop}">
    <div class="row justify-center items-center" :class="$isDesktop ? 'q-pa-xl' : 'q-pa-md'">
        <q-card v-if="$isDesktop" class="col-6">
            <common-form :action="$route('auth.authenticate')" assure-token>
                <q-card-section class="q-pa-lg q-gutter-lg">
                    <common-input name="email"
                                  v-model="form.email"
                                  label="E-mailadres"
                                  auto-complete="email"
                                  :error-message="$errorMessage('email')"
                                  :error="$hasError('email')" autofocus
                    />
                    <common-input name="password"
                                  v-model="form.password"
                                  label="Wachtwoord"
                                  type="password"
                                  :error-message="$errorMessage('password')"
                                  :error="$hasError('password')"
                    />
                    <q-checkbox name="remember_me"
                                v-model="form.remember_me"
                                true-value="1"
                                label="Ingelogd blijven" />
                </q-card-section>
                <q-separator />
                <q-card-actions align="between" class="q-py-md q-px-lg">
                    <common-link v-if="registerEnabled" label="Nog geen account" :href="$route('auth.register')" />
                    <flat-button label="Wachtwoord vergeten" @click="resetDialog = true" />
                    <flat-button v-if="ssoAvailable"
                                 outline
                                 class="q-mb-sm"
                                 label="Login met Azure"
                                 :href="$route('auth.login.withAzure')" />
                    <accent-button type="submit" label="Inloggen" />
                </q-card-actions>
            </common-form>
        </q-card>
        <div v-else class="col-xs-12 col-sm-10 q-mt-lg">
            <common-form :action="$route('auth.authenticate')" assure-token>
                <div class="row q-col-gutter-lg">
                    <common-input name="email" v-model="form.email" label="E-mailadres"
                                  class="col-12"
                                  placeholder="bob@example.com"
                                  auto-complete="email"
                                  :error-message="$errorMessage('email')"
                                  :error="$hasError('email')" autofocus
                    />
                    <common-input name="password" v-model="form.password" label="Wachtwoord" type="password"
                                  class="col-12"
                                  :error-message="$errorMessage('password')"
                                  :error="$hasError('password')"
                    />
                    <q-checkbox name="remember_me"
                                v-model="form.remember_me"
                                true-value="1"
                                label="Ingelogd blijven"
                                class="q-mb-md" />
                </div>
                <q-separator />
                <div class="row justify-between q-mt-md">
                    <flat-button label="Wachtwoord vergeten" @click="resetDialog = true" />
                    <flat-button v-if="ssoAvailable"
                                 outline
                                 class="q-mb-sm"
                                 label="Login met Azure"
                                 :href="$route('auth.login.withAzure')" />
                    <accent-button type="submit" label="Inloggen" class="q-my-sm" />
                </div>
            </common-form>
            <div v-if="registerEnabled" class="row justify-center q-mt-xl">
                <common-link label="Nog geen account" :href="$route('auth.register')" />
            </div>
        </div>
    </div>
    <password-reset-dialog v-model="resetDialog" />
</q-page>
</template>

<script>
import PasswordResetDialog from './dialog/PasswordReset'

export default {
    components: {
        PasswordResetDialog,
    },
    props: {
        ssoAvailable: {
            type: Boolean,
        },
        registerEnabled: {
            type: Boolean,
        },
    },
    data () {
        return {
            resetDialog: false,
            form: {
                email: this.$old('email'),
                password: '',
                remember_me: this.$old('remember_me', false),
            },
        }
    },
}
</script>
